// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3R-Lk","notes":"Notes_notes__3KCR9","note":"Notes_note__1j0E0","markdown":"Notes_markdown__2OB2l"};